import React from 'react'
import DashboardLayout, { DashboardPage } from '../layout'
import {makeStyles} from '@material-ui/core'
import {Tabs} from 'antd'
import Variations from './variations'
import RelevantTitles from './relevant_titles'
import UnclearTitles from './unclear_titles'
import IrrelevantTitles from './irrelevant_titles'

const {TabPane} = Tabs

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%',
        width: '100%'
    }
}))

/**
 *
 * Titles view page
 *
 */

const TitlePage = (props) => {
    const classes = useStyles()

    return (
        <DashboardLayout
            selected="title"
        >
            <DashboardPage
                title="Data Util Titles"
                hasCta={false}
            >
                <div className={classes.root}>
                    <Tabs
                        defaultActiveKey="titles"
                    >
                        <TabPane tab="Variations" key="variations">
                            <Variations />
                        </TabPane>
                        <TabPane tab="Relevant" key="relevant">
                            <RelevantTitles />
                        </TabPane>
                        <TabPane tab="Unclear" key="unclear">
                            <UnclearTitles />
                        </TabPane>
                        <TabPane tab="Irrelevant" key="irrelevant">
                            <IrrelevantTitles />
                        </TabPane>
                    </Tabs>
                </div>
            </DashboardPage>
        </DashboardLayout>
    )
}

export default TitlePage
